import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Backfill";

/**
 * Seçilen backfill işlemlerini kuyruğa alır.
 * @param {{ params?: object, query?: object }} options
 */
export const Start = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

/**
 * Backfill işinin durumunu ve sonucunu getirir.
 * @param {{ params: { jobId: string }, query?: object }} options
 */
export const GetById = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:jobId`, options);

export default {
  Start,
  GetById,
};
